import request from "../../../helpers/request";

const criarRegional = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/Regional`;
  const result = await request({ url, method: "post", data });

  if (!result) {
    throw new Error(
      "A requisição para criar a regional falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const criarLoja = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/Loja/Return`;
  const result = await request({ url, method: "post", data });

  if (!result) {
    throw new Error(
      "A requisição para criar a loja falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const criarCentral = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/DispCentral/Return`;
  const result = await request({ url, method: "post", data });

  if (!result) {
    throw new Error(
      "A requisição para criar a central falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }

  return result.data;
};

const criarModulo = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/DispModulo/Return`;
  const result = await request({ url, method: "post", data });
  if (!result) {
    throw new Error(
      "A requisição para criar o módulo falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const criarMonAnalogico = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/MonAnalogico/Return`;
  const result = await request({ url, method: "post", data });
  if (!result) {
    throw new Error(
      "A requisição para criar o monitor analógico falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const criarMonDigital = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/MonDigital/Return`;
  const result = await request({ url, method: "post", data });
  if (!result) {
    throw new Error(
      "A requisição para criar o monitor digital falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const criarMonMedidor = async (data: any) => {
  const url = `${process.env.REACT_APP_API}/MonMedidor/Return`;
  const result = await request({ url, method: "post", data });
  if (!result) {
    throw new Error(
      "A requisição para criar o monitor de medidor falhou e não retornou nada. Verifique a aba Network (F12).",
    );
  }
  return result.data;
};

const tecnicoService = {
  criarRegional,
  criarLoja,
  criarCentral,
  criarModulo,
  criarMonAnalogico,
  criarMonDigital,
  criarMonMedidor,
};

export default tecnicoService;
